// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Subsonic__DiscTitle from "./discTitle.jsx";
import * as Subsonic__Genre from "./genre.jsx";
import * as Subsonic__ReleaseDate from "./releaseDate.jsx";
import * as Subsonic__Response from "./response.jsx";
import * as Subsonic__Song from "./song.jsx";

function album_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.artist;
  const v$1 = x.artistId;
  const v$2 = x.coverArt;
  const v$3 = x.discTitles;
  const v$4 = x.duration;
  const v$5 = x.genre;
  const v$6 = x.genres;
  const v$7 = x.id;
  const v$8 = x.isCompilation;
  const v$9 = x.musicBrainzId;
  const v$10 = x.name;
  const v$11 = x.originalReleaseDate;
  const v$12 = x.releaseDate;
  const v$13 = x.song;
  const v$14 = x.songCount;
  const v$15 = x.starred;
  const v$16 = x.userRating;
  const v$17 = x.year;
  return {
    artist: v !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v) : Ppx_deriving_json_runtime.of_json_error("missing field \"artist\""),
    artistId: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"artistId\""),
    coverArt: v$2 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$2) : Ppx_deriving_json_runtime.of_json_error("missing field \"coverArt\""),
    discTitles: v$3 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json((function (param) {
        return Ppx_deriving_json_runtime.Primitives.array_of_json(Subsonic__DiscTitle.of_json, param);
      }), v$3) : undefined,
    duration: v$4 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.float_of_json, v$4) : undefined,
    genre: v$5 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$5) : undefined,
    genres: v$6 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json((function (param) {
        return Ppx_deriving_json_runtime.Primitives.array_of_json(Subsonic__Genre.of_json, param);
      }), v$6) : undefined,
    id: v$7 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$7) : Ppx_deriving_json_runtime.of_json_error("missing field \"id\""),
    isCompilation: v$8 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.bool_of_json, v$8) : undefined,
    musicBrainzId: v$9 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$9) : undefined,
    name: v$10 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$10) : Ppx_deriving_json_runtime.of_json_error("missing field \"name\""),
    originalReleaseDate: v$11 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Subsonic__ReleaseDate.of_json, v$11) : undefined,
    releaseDate: v$12 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Subsonic__ReleaseDate.of_json, v$12) : undefined,
    song: v$13 !== undefined ? Ppx_deriving_json_runtime.Primitives.array_of_json(Subsonic__Song.of_json, v$13) : Ppx_deriving_json_runtime.of_json_error("missing field \"song\""),
    songCount: v$14 !== undefined ? Ppx_deriving_json_runtime.Primitives.int_of_json(v$14) : Ppx_deriving_json_runtime.of_json_error("missing field \"songCount\""),
    starred: v$15 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$15) : undefined,
    userRating: v$16 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v$16) : undefined,
    year: v$17 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v$17) : undefined
  };
}

function album_to_json(x) {
  return {
    artist: x.artist,
    artistId: x.artistId,
    coverArt: x.coverArt,
    discTitles: Ppx_deriving_json_runtime.Primitives.option_to_json((function (param) {
      return Ppx_deriving_json_runtime.Primitives.array_to_json(Subsonic__DiscTitle.to_json, param);
    }), x.discTitles),
    duration: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.duration),
    genre: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.genre),
    genres: Ppx_deriving_json_runtime.Primitives.option_to_json((function (param) {
      return Ppx_deriving_json_runtime.Primitives.array_to_json(Subsonic__Genre.to_json, param);
    }), x.genres),
    id: x.id,
    isCompilation: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.isCompilation),
    musicBrainzId: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.musicBrainzId),
    name: x.name,
    originalReleaseDate: Ppx_deriving_json_runtime.Primitives.option_to_json(Subsonic__ReleaseDate.to_json, x.originalReleaseDate),
    releaseDate: Ppx_deriving_json_runtime.Primitives.option_to_json(Subsonic__ReleaseDate.to_json, x.releaseDate),
    song: Ppx_deriving_json_runtime.Primitives.array_to_json(Subsonic__Song.to_json, x.song),
    songCount: x.songCount,
    starred: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.starred),
    userRating: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.userRating),
    year: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.year)
  };
}

function body_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.status;
  let tmp;
  if (v !== undefined) {
    const tag = Ppx_deriving_json_runtime.Primitives.string_of_json(v);
    tmp = tag === "ok" ? "ok" : Ppx_deriving_json_runtime.of_json_error("invalid JSON");
  } else {
    tmp = Ppx_deriving_json_runtime.of_json_error("missing field \"status\"");
  }
  const v$1 = x.album;
  return {
    status: tmp,
    album: v$1 !== undefined ? album_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"album\"")
  };
}

function body_to_json(x) {
  return {
    status: "ok",
    album: album_to_json(x.album)
  };
}

function of_json(x) {
  return Subsonic__Response.of_json(body_of_json, x);
}

function to_json(x) {
  return Subsonic__Response.to_json(body_to_json, x);
}

export {
  album_of_json,
  album_to_json,
  body_of_json,
  body_to_json,
  of_json,
  to_json,
}
/* No side effect */
